export const selectEditTransaction = state => state.modal.isEdit;
export const selectOpenModalAdd = state => state.modal.isAdd;
export const selectOpenLogOut = state => state.modal.isExit;
export const selectDeleteModal = state => state.modal.isDelete;
